export const BLOG_POSTS = [
  {
    slug: "ile-kosztuje-strona-firmowa-2026",
    date: "2026-06-15",
    title: {
      pl: "Ile kosztuje strona firmowa w 2026?",
      en: "How much does a company website cost in 2026?",
    },
    excerpt: {
      pl: "Przejrzysty przewodnik po budżetach — od wizytówki cyfrowej po pełną stronę firmową z charakterem. Bez ukrytych kosztów.",
      en: "A clear guide to budgets — from a digital calling card to a full company website with character. No hidden costs.",
    },
    body: {
      pl: [
        "Pytanie „ile kosztuje strona?” pojawia się na początku niemal każdej rozmowy. Odpowiedź brzmi: zależy — ale można to uporządkować.",
        "Prosta wizytówka cyfrowa (1–3 ekrany) to zazwyczaj 1 500–3 000 zł. Strona firmowa z pełnym motion designem, SEO i mobile-first — od 6 000 zł. Aplikacja webowa lub SaaS zaczyna się od 12 000 zł.",
        "Co wpływa na cenę? Zakres ekranów, integracje (CRM, płatności, CMS), ilość animacji, terminy i złożoność backendu.",
        "U nas każdy projekt zaczyna się od rozmowy — po briefie dostajesz konkretną wycenę, harmonogram i zakres. Bez pakietów „z półki”.",
      ],
      en: [
        "“How much does a website cost?” comes up at the start of almost every conversation. The answer: it depends — but it can be structured.",
        "A simple digital calling card (1–3 screens) is usually €400–800. A company website with full motion design, SEO and mobile-first — from €1 500. A web app or SaaS starts around €3 000.",
        "What affects price? Screen scope, integrations (CRM, payments, CMS), animation volume, deadlines and backend complexity.",
        "With us every project starts with a conversation — after the brief you get a specific quote, timeline and scope. No off-the-shelf packages.",
      ],
    },
    meta: {
      pl: {
        title: "Ile kosztuje strona firmowa w 2026? | Blog Przestrzeń Apps",
        description: "Przewodnik po budżetach stron firmowych w 2026 — od wizytówki po pełną stronę z motion designem.",
      },
      en: {
        title: "How much does a company website cost in 2026? | Przestrzeń Apps Blog",
        description: "A 2026 guide to company website budgets — from calling card to full site with motion design.",
      },
    },
  },
];

export function getBlogPost(slug) {
  return BLOG_POSTS.find((p) => p.slug === slug) ?? null;
}